import React, { useState, useEffect } from "react";
import medicinebanner from "../assets/images/medicin_banner.png";
import "./MedicalEquipments.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Filter from "../layout/Filter";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useLocation } from "react-router-dom";
import Equipments from "./Equipments";
import Testimonial from "../layout/Home/Testimonial";
import Review from "../layout/Home/Review";
import Faq from "../layout/Home/Faq";
import OrderMedicine from "./OrderMedicine";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { fetchAPI } from "../utils/api";

import faqimage from "../assets/images/faqimage.png";
import Accordion from "react-bootstrap/Accordion";
import FaqData from "../layout/Faqdata"; 

const banner = [
  {
    id: 1,
    image: medicinebanner,
  },
  {
    id: 2,
    image: medicinebanner,
  },
  {
    id: 3,
    image: medicinebanner,
  },
];

function MedicalEquipments() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedAttributeValues, setSelectedAttributeValues] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get("search");
    setSearchQuery(q || "");
  }, [location.search]);

  // Fetch Category, Attribute, and Product Data on mount
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const [catData, attrData, prodData] = await Promise.all([
          fetchAPI("EquipmentsController/category"),
          fetchAPI("EquipmentsController/attributes"),
          fetchAPI("EquipmentsController/products", {
            method: "POST",
            body: JSON.stringify({}),
          }),
        ]);

        if (catData.status === 200) {
          setCategories(catData.result || []);
        }
        if (attrData.status === 200) {
          setAttributes(attrData.result || []);
        }
        if (prodData.status === 200) {
          setProducts(prodData.result || []);
          setFilteredProducts(prodData.result || []);
        }
      } catch (err) {
        console.error("Error loading equipment data:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // Filter products locally based on active filters
  useEffect(() => {
    let result = products;

    // Search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      result = result.filter(
        (prod) =>
          prod.me_product_name &&
          prod.me_product_name.toLowerCase().includes(query)
      );
    }

    // Category filter
    if (selectedCategories.length > 0) {
      result = result.filter((prod) =>
        selectedCategories.includes(String(prod.me_category))
      );
    }

    // Attribute Values filter
    if (selectedAttributeValues.length > 0) {
      result = result.filter((prod) => {
        if (!prod.attribute || prod.attribute.length === 0) return false;
        return prod.attribute.some((attr) =>
          selectedAttributeValues.includes(Number(attr.attribute_value_id))
        );
      });
    }

    setFilteredProducts(result);
  }, [searchQuery, selectedCategories, selectedAttributeValues, products]);

  const handleCategoryChange = (catId) => {
    setSelectedCategories((prev) => {
      const idStr = String(catId);
      if (prev.includes(idStr)) {
        return prev.filter((id) => id !== idStr);
      } else {
        return [...prev, idStr];
      }
    });
  };

  const handleAttributeChange = (valId) => {
    setSelectedAttributeValues((prev) => {
      const valNum = Number(valId);
      if (prev.includes(valNum)) {
        return prev.filter((id) => id !== valNum);
      } else {
        return [...prev, valNum];
      }
    });
  };

  const handleClearAll = () => {
    setSelectedCategories([]);
    setSelectedAttributeValues([]);
  };

  return (
    <>
      <Header />
      <div className="test_bredcum_sec with_background">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <span className="name_p">Products on Rent</span>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="services_filter_caregiver">
          <div className="row">
            <div className="col-xl-3 col-lg-4">
              <Filter 
                open={open} 
                setOpen={setOpen} 
                isDynamic={true}
                categories={categories}
                selectedCategories={selectedCategories}
                onCategoryChange={handleCategoryChange}
                attributes={attributes}
                selectedAttributeValues={selectedAttributeValues}
                onAttributeChange={handleAttributeChange}
                onClearAll={handleClearAll}
                loading={loading}
              />
            </div>
            <div className="col-xl-9 col-lg-8 col-sm-12 col-12">
              <div className="right_side_header_test">
                <div>
                  <div className="product_heading_peraa">
                    <h1 className="productpg_maine_heading">Products on Rent in Jaipur </h1>
                    <p className="productpg_maine_peraa">Get affordable <a href="/product-on-rent"> products on rent in Jaipur</a> for patient care, recovery, and home healthcare needs.</p>
                  </div> 
                  <div className="filter_btn">
                    <button
                       className="filter_btn"
                      onClick={() => setOpen(true)}
                    >
                      <TuneRoundedIcon />
                    </button>
                  </div>
                </div>

                <div className="search_bar_test_sec d-block">
                  <div className="main_serach_bar_test">
                    <form 
                      className="search-form_test caregiver_sev_box_h"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <input
                        type="search"
                        placeholder="Search Products.........."
                        className="search_input"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <button type="button" className="search_btn">
                        <SearchIcon />
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              <div className="caregiver_serv_boxes">
                <div className="row">
                  <Equipments equipments={filteredProducts} loading={loading} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      


     <div className="faq_sec">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4">
                  <div className="section_heading ">
                    <h2>
                      Frequently Asked <span>Questions </span>
                    </h2>
                  </div>
                  <div className="faq-image">
                    <img src={faqimage} alt="productonrent-faq-img" className="img-fluid" />
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="faq-main">
                     <Accordion defaultActiveKey="0">
                        {FaqData
                          .filter((item) => item.page === "productonrent")
                          .map((item, index) => (
                            <Accordion.Item
                              eventKey={index.toString()}
                              key={item.id}
                            >
                              <Accordion.Header as="h3">{item.title}</Accordion.Header>
                              <Accordion.Body>{item.content}</Accordion.Body>
                            </Accordion.Item>
                          ))}
                      </Accordion>
                  </div>
                </div>
              </div>
            </div>
     </div>

     <div className="product_on_rent_footer">
       <div className="container-fluid">
         <div className="inner_product_footer">
           <div className="first_sec_footer">
             <h4>What Do Products on Rent Include?</h4>
             <p>Products on rent include essential equipment and support products for patient care, recovery, and daily assistance at home. Renting provides families with flexible and affordable access to the products they need without purchasing them.</p>
           </div>
           <div className="second_sec-footer">
             <h5>Benefits of Choosing Products on Rent</h5>
             <p>Choosing <a href="/product-on-rent">products on rent in Jaipur</a>  is a convenient and cost-effective solution for home healthcare needs.</p>
             <ul>
                <li><a href="/product-on-rent">Cost-Effective Solution:</a>  Reduce upfront expenses by renting products instead of purchasing them.</li>
                <li><a href="/product-on-rent">Flexible Rental Periods:</a>  Choose rental durations based on temporary or long-term care requirements.</li>
                <li><a href="/product-on-rent"> Convenient Home Care: </a>Access essential products to support patient comfort and everyday care at home.</li>
                <li><a href="/product-on-rent">Support During Recovery:</a>  Arrange suitable products to assist patients during post-operative recovery and rehabilitation.</li>
                <li><a href="/product-on-rent">Reduced Storage Needs:</a>  Avoid storing equipment permanently when it is no longer required.</li>
                <li><a href="/product-on-rent">Easy Access to Essential Products:</a>  Help families arrange suitable products for changing patient care needs.</li>
             </ul>
           </div>
         </div>
       </div>
     </div>


      <Footer />
    </>
  );
}

export default MedicalEquipments;
